<script lang="ts">
  import type { Snippet } from "svelte";
  import type { HTMLInputAttributes } from "svelte/elements";

  interface Props extends HTMLInputAttributes {
    value: string;
    group: any;
    label?: string;
    hideLabel?: boolean;
    children?: Snippet;
  }

  let {
    value,
    group = $bindable(),
    label = "",
    hideLabel = false,
    children,
    ...rest
  }: Props = $props();
</script>

<label class="option">
  <input class="sr-only" type="radio" {value} {...rest} bind:group />

  {#if label}
    <span class={hideLabel ? "sr-only" : ""}>
      {label}
    </span>
  {/if}

  {@render children?.()}
</label>

<style>
  @reference "#tailwind.css";
  .option {
    @apply flex h-full cursor-pointer items-center justify-center rounded-full border border-transparent px-2 transition-colors hover:text-foreground-primary has-[:checked]:bg-mono-100 has-[:checked]:text-foreground-primary has-[:checked]:shadow-border;
  }
</style>
